import store from './store';

export * from './actions';

export default {
  store
};
